import { ImageComponentConfig } from '../image/image-component-config.interface';
import { TextComponentConfig } from '../text/text-component-config.interface';

export interface CompareTableHeader {
  text: TextComponentConfig;
  image: ImageComponentConfig;
}
